<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="12" md="6">
                  <span>Report Details</span>
                </b-col>
                <b-col cols="12" md="6">
                  <b-dropdown
                    variant="outline-primary"
                    size="sm"
                    id="dropdown-1"
                    :text="updateName"
                  >
                    <b-dropdown-item @click="updateReport(-1)">Initial Report</b-dropdown-item>
                    <b-dropdown-item
                      v-for="(item,i) in updates"
                      :key="i"
                      @click="updateReport(i)"
                    >Update {{i+1}}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="ml-auto text-right">
              <b-button
                variant="outline-primary"
                size="sm"
                router-link
                :to="'/Similar/'+id"
              >Similar Incidents</b-button>
            </b-col>
          </b-row>
        </template>
        <div v-if="report">
          <b-row>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Case ID</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{report.caseid}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Been Cut</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{report.beencut}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Have Been Cut</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{report.havebeencut}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Might Be Cut</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{report.mightbecut}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="8" md="5">
                  <span class="item_title">Is Anonymous</span>
                </b-col>
                <b-col cols="4" md="7">
                  <span class="item_value">{{report.isanonymous}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Created Date</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span class="item_value">{{formatDate(report.createddate)}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Location</span>
                </b-col>
                <b-col cols="12" md="7">
                  <router-link :to="'/Map/'+report._id">
                    <span class="item_value">{{report.locationname}}</span>
                  </router-link>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">Cut Reason</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span class="item_value" v-for="(item,i) in report.mightbecutreason" :key="i">
                    &bull;&nbsp;{{item}}
                    <br />
                  </span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <span class="item_title">Photos</span>
            </b-col>
            <b-col cols="12" md="4" v-for="(item,i) in photos" :key="i" align="center" class="py-2">
              <img :src="baseURL+'/u/'+item.photo" width="auto" height="200px" />
            </b-col>
          </b-row>
          <hr />
          <!-- User Details -->
          <b-row>
            <b-col cols="12" class="py-2">
              <span class="item_title" style="font-size:18px">Added By</span>
            </b-col>
            <b-col v-if="user.photo" cols="12" class="py-2">
              <img :src="baseURL+'/u/'+user.photo" height="100px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.name}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.phonePrefix}}&nbsp;{{user.phone}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Age</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.age}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Occupation</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.occupation}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Country</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.country}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="6" md="5">
                  <span class="item_title">Phone Verified</span>
                </b-col>
                <b-col cols="6" md="7">
                  <span class="item_value">{{user.isPhoneVerified}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Gender</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.gender}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User ID</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.userid}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                v-if="report.isinwatchlist"
                variant="outline-danger"
                @click="addToWatchlist('true')"
                size="sm"
              >Remove from Watchlist</b-button>
              <b-button
                v-else
                variant="outline-primary"
                @click="addToWatchlist('false')"
                size="sm"
              >Add to Watchlist</b-button>
            </div>
            <div class="px-2" v-if="superAdmin">
              <b-button variant="outline-danger" @click="confirmBox" size="sm">Remove</b-button>
            </div>
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      fullReport: null,
      report: null,
      user: null,
      photos: [],
      appLoading: false,
      id: null,
      map: null,
      oMarker: [],
      updates: [],
      updateName: "Initial Report",
      ServerError: false,
      superAdmin: false
    };
  },
  beforeMount() {
    this.getData();
    if (localStorage.getItem("role") != "Sub Admin") this.superAdmin = true;
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/get",
        params: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.fullReport = response.data.data;
          this.report = this.fullReport;
          this.updates = this.fullReport.updates;
          this.id = this.report._id;
          this.user = this.report.addedby;
          this.photos = this.report.photos;
        })
        .catch(e => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    updateReport(item) {
      if (item == -1) {
        this.report = this.fullReport;
        this.id = this.report._id;
        this.user = this.report.addedby;
        this.photos = this.report.photos;
        this.updateName = "Initial Report";
      } else {
        this.report = this.updates[item];
        this.id = this.report._id;
        this.user = this.report.addedby;
        this.photos = this.report.photos;
        this.updateName = "Update " + (1 + item);
      }
    },
    confirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to remove this incident.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.removeIncident();
          }
        })
        .catch(err => {
          this.ServerError = true;
        });
    },
    addToWatchlist(item) {
      this.appLoading = true;
      var url;
      if (item == "true") {
        url = "/incident/watchlist/remove";
      } else {
        url = "/incident/watchlist/add";
      }
      axios({
        method: "POST",
        url: url,
        data: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.getData();
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    removeIncident() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/remove",
        params: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch(e => {
          this.ServerError = true;
        });
    }
  }
};
</script>